export default "__VITE_ASSET__DfzGJA8X__"